export default __webpack_public_path__ + "static/media/error-robot.518727c7.png";